import React, { useState, useEffect, Fragment } from 'react';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react';
import ReactTable from 'components/ReactTable/ReactTable.js';
import {
  ArrowDropDown,
  ArrowDropUp,
  Assignment,
  Visibility,
  NewReleases,
  Sync,
  CheckBoxOutlineBlank,
} from '@material-ui/icons';
import {
  Box,
  FormControl,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
} from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';

import { wsGetAll, wsFindBy, wsUpdate } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import ModalTaxe from './Modal/ModalTaxe';
import ModalProducts from './Modal/ModalProducts';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { currency } from 'hooks/Pipe';
import { onlyInteger } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    color: 'black',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    '& span': {
      fontSize: 18,
    },
  },
  containBox: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      margin: 0,
      marginRight: 10,
      marginLeft: 10,
      color: 'white',
      borderRadius: 5,
    },
  },
  total: { fontZise: '16px !important' },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      color: '#000000bf',
      fontWeight: 'bold',
      fontSize: '18px',
    },
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 200 },
  { Header: 'Correlativo', accessor: 'linenum', width: 130 },
  { Header: 'U.M.', accessor: 'UnitMsr', width: 100 },
  { Header: '# Pzs', accessor: 'NumPerMsr', width: 100 },
  { Header: 'U.M. SAP', accessor: 'UnitMsrSAP', width: 110 },
  { Header: '# Pzs SAP', accessor: 'NumPerMsrSAP', width: 110 },
  { Header: 'Cantidad', accessor: 'quantity', width: 130 },
  { Header: 'Ing. Alma.', accessor: 'ing_warehose', width: 150 },
  { Header: 'Descripción XML', accessor: 'Dscription' },
  { Header: 'Cód. producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre Producto', accessor: 'ItemName' },
  { Header: 'Precio', accessor: 'price', width: 130 },
  { Header: 'Últ. Precio', accessor: 'last_purchase_price', width: 130 },
  { Header: 'Antes desc.', accessor: 'PriceBefDi', width: 130 },
  { Header: 'Después Igv', accessor: 'PriceAfVAT', width: 130 },
  { Header: 'Cód. impuesto', accessor: 'tax_code', width: 130 },
  { Header: 'T. línea sin Igv', accessor: 'LineTotal', width: 130 },
  { Header: 'Cód. prod. prov.', accessor: 'FrgItem', width: 150 },
  { Header: 'Cód. Almacén', accessor: 'whscode', width: 130 },
  { Header: 'Almacén', accessor: 'warehouse' },
  { Header: '% Desc.', accessor: 'DiscPrcnt', width: 120 },
  { Header: 'Monto Desc.', accessor: 'DiscSum', width: 130 },
  { Header: '% Igv', accessor: 'vatprcnt', width: 100 },
  { Header: 'Monto Igv', accessor: 'vatsum', width: 120 },
  { Header: 'Total línea Igv', accessor: 'gtotal', width: 130 },
  { Header: '% Impuesto', accessor: 'isc_prcnt', width: 120 },
  { Header: 'Monto del Isc', accessor: 'isc_sum', width: 130 },
  { Header: 'Cód. tipo precio', accessor: 'PriceTypeCode', width: 140 },
  { Header: 'Tipo doc. destino', accessor: 'TargetType', width: 150 },
  { Header: 'Doc. destino', accessor: 'TargetEntry', width: 140 },
  { Header: 'Línea doc. destino', accessor: 'TargetLine', width: 160 },
  { Header: '% Cargo', accessor: 'chargePercent', width: 120 },
  { Header: 'Monto cargo', accessor: 'chargeAmount', width: 120 },
  { Header: 'Unidad', accessor: 'UseBaseUn', width: 110 },
  { Header: 'Compra', accessor: 'PrchseItem', width: 110 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Invoice(props) {
  const classes = useStyles();
  const { idUrl, showNotify, buyDetail, reload } = props;

  const [open, setOpen] = useState(false);

  const [shoppingDetails, setShoppingDetails] = useState([]);
  const [dataShop, setDataShop] = useState({});
  const [uManejos, setUManejos] = useState([]);
  const [purchOrders, setPurchOrders] = useState([]);

  const [header, setHeader] = useState({});

  const [openModalProducts, setOpenModalProducts] = useState(false);
  const disabledButton = !purchOrders?.length || !shoppingDetails?.length || buyDetail.validate_purch_order_at !== null;

  const handleChangeRow = (e, id) => {
    let objIndex = shoppingDetails.findIndex((obj) => obj.id == id);
    shoppingDetails[objIndex][e.target.name] = e.target.value;
    setShoppingDetails([...shoppingDetails]);
  };

  async function listUManejo() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setUManejos(response.data);
  }

  async function listShoppingDetails() {
    let response = await wsFindBy('purch/purchase-detail', 'purch_purchase_id', idUrl);
    if (response.success) {
      response.data.sort((a, b) => {
        return a.logi_product_id === null ? -1 : 1;
      });
      setShoppingDetails(response.data);

      let LineTotal = 0;
      let VatSum = 0;
      let gtotal = 0;
      let isc_sum = 0;

      for (let detail in response.data) {
        LineTotal += parseFloat(response.data[detail].LineTotal);
        VatSum += parseFloat(response.data[detail].VatSum);
        gtotal += parseFloat(response.data[detail].gtotal);
        isc_sum += parseFloat(response.data[detail].isc_sum);
      }
      setHeader({
        LineTotal: LineTotal.toFixed(2),
        VatSum: VatSum.toFixed(2),
        gtotal: gtotal.toFixed(2),
        isc_sum: isc_sum.toFixed(2),
      });
    }
  }

  async function listPurchOrder() {
    let response = await wsFindBy('purch/purchase-order-detalle', 'purch_order_id', buyDetail.purch_order_id);
    if (response.success) setPurchOrders(response.data);
  }

  async function refreshDataArticle(detailId, productId) {
    let response = await wsUpdate('purch/purchase-detail', detailId, {
      logi_product_id: productId,
    });
    if (response.success) {
      showNotify(response.message);
      listShoppingDetails();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateDetail(idDetail, data) {
    let response = await wsUpdate('purch/purchase-detail', idDetail, data);
    if (response.success) {
      showNotify(response.message);
      listShoppingDetails();
    } else {
      showNotify(response.message, 'error');
      listShoppingDetails();
    }
  }

  const filterColumns = () => {
    let dataColumns = columns.map((item) => {
      if (item.accessor === 'UnitMsr') item.accessor = 'UnitMsrUpdate';
      if (item.accessor === 'NumPerMsr') item.accessor = 'NumPerMsrUpdate';
      return item;
    });
    return dataColumns;
  };

  useEffect(() => {
    listShoppingDetails();
    if (buyDetail.proc_status === 'D') {
      listUManejo();
    }
    return () => setShoppingDetails([]);
  }, [buyDetail]);

  useEffect(() => {
    if(buyDetail.purch_order_id && shoppingDetails){
      listPurchOrder();
    }
  },buyDetail.purch_order_id);

  return (
    <Fragment>
      <ModalTaxe
        open={open}
        setOpen={setOpen}
        dataShop={dataShop}
        buyDetail={buyDetail}
        reload={listShoppingDetails}
      />
      {openModalProducts && (
        <ModalProducts
          open={openModalProducts} 
          onClose={() => 
            setOpenModalProducts(false)
          }
          showNotify={showNotify}
          ordersProducts= {purchOrders}
          purchProducts= {shoppingDetails}
          purchOrderId={buyDetail.purch_order_id}
          purchaseId={buyDetail.id}
          reload={reload}/>
      )}

      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <div className={classes.cardIconTitle}>
            <span>
              <strong>Detalle de la compra</strong>
            </span>
            <div className={classes.containBox}>
              <CheckBoxOutlineBlank style={{ backgroundColor: '#00ffff' }} /> No es compra
              <CheckBoxOutlineBlank style={{ backgroundColor: '#efff00' }} /> No existe producto |
              precio
              <CheckBoxOutlineBlank style={{ backgroundColor: '#ff7a7a' }} /> Sube precio
              <CheckBoxOutlineBlank style={{ backgroundColor: '#00d11a' }} /> Baja precio
            </div>
          </div>
          {buyDetail.purch_order_id !== null ? (
            <Button
            color={props.themeContext.buttonColorDanger}
            style={{ marginTop: '15px', float: 'right' }}
            onClick={() => setOpenModalProducts(true)}
            disabled={disabledButton}
            >
              Validación de orden de compra
            </Button>
          ) : undefined}
        </CardHeader>
        <CardBody>
          <GridContainer style={{ marginBottom: '15px' }}>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Total de línea sin Igv: </h5>
                <span>{currency(header.LineTotal)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Monto de Igv: </h5>
                <span>{currency(header.VatSum)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Total de línea con Igv: </h5>
                <span>{currency(header.gtotal)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Monto del Isc: </h5>
                <span>{currency(header.isc_sum)}</span>
              </Paper>
            </GridItem>
          </GridContainer>
          <ReactTable
            /* exportExcel={buyDetail.proc_status !== 'D'}
            excelName="Detalle-de-la-compra" */
            exportExcel={false}
            defaultWidth={5000}
            colorRow={(item) => {
              let priceInUnits =
                item.price > 0 && item.NumPerMsr > 0
                  ? parseFloat(item.price / item.NumPerMsr || 0).toFixed(2)
                  : 0;
              let lasPurchase =
                item.last_purchase_price > 0
                  ? parseFloat(item.last_purchase_price || 0).toFixed(2)
                  : 0;
              let color = '';
              if (item.PrchseItem === 'No') {
                color = '#00ffff26';
              } else if (priceInUnits == 0) {
                color = '#fcffe1'; // amarillo
              } else if (priceInUnits > lasPurchase && (priceInUnits - lasPurchase) > 0.01) {
                color = '#ff00001f'; // rojo
              } else if (priceInUnits < lasPurchase && (lasPurchase - priceInUnits) > 0.01) {
                color = '#00d11a45'; // verde
              }
              return color;
            }}
            columns={buyDetail.proc_status !== 'D' ? columns : filterColumns()}
            data={shoppingDetails.map((buy, i) => {
              let priceInUnits =
                buy.price > 0 && buy.NumPerMsr > 0
                  ? parseFloat(buy.price / buy.NumPerMsr || 0).toFixed(2)
                  : 0; //precio normal
              let lasPurchase =
                buy.last_purchase_price > 0
                  ? parseFloat(buy.last_purchase_price || 0).toFixed(2)
                  : 0; // ultimo precio de compra
              return {
                num: (
                  <Box display="flex" alignItems="center">
                    {i + 1}
                    <Button
                      disabled={buy.logi_product_id !== null}
                      justIcon
                      simple
                      color={
                        buy.logi_product_id !== null
                          ? props.themeContext.buttonColor
                          : props.themeContext.buttonColorWarning
                      }
                      onClick={() => {
                        setDataShop(buy);
                        setOpen(true);
                      }}
                    >
                      <Visibility />
                    </Button>

                    <Button
                      justIcon
                      simple
                      color={props.themeContext.buttonColorWarning}
                      onClick={() => {
                        if (!buy.logi_product_id) {
                          showNotify('El ID del producto es null', 'info');
                          return;
                        }
                        refreshDataArticle(buy.id, buy.logi_product_id);
                      }}
                      disabled={buyDetail.proc_status !== 'D'}
                    >
                      <Sync />
                    </Button>
                    {buy.PrchseItem === 'N' ? (
                      <Tooltip title="Este producto no esta configurado para compras">
                        <NewReleases
                          style={{
                            fontSize: '25px',
                            color: '#00b1c3',
                            cursor: 'pointer',
                          }}
                        />
                      </Tooltip>
                    ) : undefined}
                    {priceInUnits > lasPurchase ? (
                      <Tooltip
                        title={(parseFloat(priceInUnits) - parseFloat(lasPurchase)).toFixed(2)}
                      >
                        <ArrowDropUp
                          style={{
                            fontSize: '35px',
                            color: 'red',
                            cursor: 'pointer',
                          }}
                        />
                      </Tooltip>
                    ) : priceInUnits < lasPurchase ? (
                      <Tooltip
                        title={(parseFloat(lasPurchase) - parseFloat(priceInUnits)).toFixed(2)}
                      >
                        <ArrowDropDown
                          style={{
                            fontSize: '35px',
                            color: 'green',
                            cursor: 'pointer',
                          }}
                        />
                      </Tooltip>
                    ) : undefined}
                  </Box>
                ),
                linenum: buy.LineNum,
                UnitMsr: buy.UnitMsr,
                UnitMsrUpdate: (
                  <FormControl fullWidth margin="normal" size="small">
                    <Select
                      /* value={uManejos.find((item) => item.UgpCode == buy.UnitMsr)?.UgpCode || ''} */
                      value={buy.UnitMsr || ''}
                    >
                      {uManejos.map((umj, i) => (
                        <MenuItem
                          key={i}
                          value={umj.FECUM}
                          onClick={(e) => updateDetail(buy.id, { UnitMsr: umj.UgpCode })}
                        >
                          {umj.UgpName}
                        </MenuItem>
                      ))}
                      <MenuItem value={buy.UnitMsr}>{buy.UnitMsr}</MenuItem>
                    </Select>
                  </FormControl>
                ),
                NumPerMsr: buy.NumPerMsr,
                NumPerMsrUpdate: (
                  <TextField
                    value={buy.NumPerMsr || ''}
                    size="small"
                    margin="normal"
                    name="NumPerMsr"
                    onChange={(e) => handleChangeRow(e, buy.id)}
                    onKeyPress={onlyInteger}
                    onBlur={(e) => updateDetail(buy.id, { NumPerMsr: e.target.value })}
                  />
                ),
                UnitMsrSAP: buy.UnitMsrSAP,
                NumPerMsrSAP: parseInt(buy.NumPerMsrSAP || 0),
                quantity: buy.quantity,
                ing_warehose: parseInt(buy.NumPerMsr || 0) * parseFloat(buy.quantity || 0),
                Dscription: buy.Dscription,
                ItemCode: buy.ItemCode,
                ItemName: buy.ItemName,
                price: buy.price,
                last_purchase_price: parseFloat(buy.last_purchase_price || 0).toFixed(2),
                PriceBefDi: buy.PriceBefDi,
                PriceAfVAT: buy.PriceAfVAT,
                tax_code: buy.tax_code,
                LineTotal: buy.LineTotal,
                FrgItem: buy.FrgItem,
                whscode: buy.WhsCode,
                warehouse: buy.WhsName,
                DiscPrcnt: buy.DiscPrcnt + '%',
                DiscSum: buy.DiscSum,
                vatprcnt: buy.VatPrcnt + '%',
                vatsum: buy.VatSum,
                gtotal: buy.gtotal,
                isc_prcnt: buy.isc_prcnt + '%',
                isc_sum: buy.isc_sum,
                PriceTypeCode: buy.PriceTypeCode,
                TargetType: buy.TargetType,
                TargetEntry: buy.TargetEntry,
                TargetLine: buy.TargetLine,
                chargePercent: buy.charge_percent,
                chargeAmount: buy.charge_amount,
                UseBaseUn: buy.UseBaseUn === 'Y' ? 'Unidades' : 'Cajas',
                PrchseItem: buy.PrchseItem === 'Y' ? 'Si' : 'No',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
